import PropTypes from 'prop-types';
import React from 'react';
import useOAuthCallback from '../../hooks/useOAuthCallback';

/**
 * Wrapper component that handles OAuth callbacks.
 * Place this inside the Router to automatically process OAuth redirects.
 *
 * @param {string} redirectTo - Path to redirect after successful auth
 */
const OAuthCallbackHandler = ({ children, redirectTo }) => {
  useOAuthCallback(redirectTo);
  return <>{children}</>;
};

OAuthCallbackHandler.propTypes = {
  children: PropTypes.node.isRequired,
  redirectTo: PropTypes.string,
};

OAuthCallbackHandler.defaultProps = {
  redirectTo: '/app/home',
};

export default OAuthCallbackHandler;

